import { Card, Stack, Typography } from '@mui/material';

interface Props {
    icon?: React.ReactNode;
    title?: string;
    value?: string;
}

export const ResultsSummaryCard: React.FC<Props> = ({ icon, title, value }) => {
    return (
        <Card sx={(theme) => ({ p: 2, minWidth: 200, backgroundColor: (theme.vars || theme).palette.grey[100] })}>
            <Stack direction='row' spacing={2} sx={{ alignItems: 'center' }}>
                {icon}
                <Stack spacing={1} sx={{ justifyContent: 'center' }}>
                    <Typography color='text.secondary'>{title?.toUpperCase()}</Typography>
                    <Typography color='text.primary' variant='h5'>
                        {value}
                    </Typography>
                </Stack>
            </Stack>
        </Card>
    );
};
